import Model from '@/models/Model';

export default class Operator extends Model {
    get route () {
        return 'operators';
    }

    static get className () {
        return 'Operator';
    }

    static get isInStore () {
        return true;
    }
}
